/**
 * Trailing-edge coalescing: however many times `trigger()` is called within
 * `delayMs`, `fn` runs once, `delayMs` after the last call.
 *
 * Used by the Inbox's live stream: the server already collapses a burst of
 * stored messages into one signal per ~0.5s, but a tab can still receive
 * several signals in a row (poller + sentiment landing + a teammate's
 * mark-as-read), and each one would otherwise re-run the list, stats and
 * people requests. One refresh per burst is what the page needs.
 */
export function coalesce(fn: () => void, delayMs: number): { trigger: () => void; cancel: () => void } {
  let timer: ReturnType<typeof setTimeout> | undefined
  return {
    trigger() {
      if (timer !== undefined) clearTimeout(timer)
      timer = setTimeout(() => {
        timer = undefined
        fn()
      }, delayMs)
    },
    cancel() {
      if (timer !== undefined) clearTimeout(timer)
      timer = undefined
    },
  }
}
